// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
    display: block;
}

.new-project-container {
    width: 100%;
    min-height: 100vh;
    margin: 0;
    padding: 2rem 0 0 0;
    background: #fff;
    position: relative;
    z-index: 1;
    margin-left: 0;
    margin-right: 0;
}

.new-project-form {
    background: #fff;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.tab-content {
    padding: 2rem;
    background: #fff;
    border-radius: 0;
    flex: 1;
    overflow-y: auto;
}

.submit-section {
    padding: 2rem 2rem 2rem 2rem;
    background: #fff;
    border-radius: 0;
    text-align: center;
    border-top: 1px solid #e9ecef;
}

.submit-button {
    background: linear-gradient(135deg, #f09502, #ff6b35);
    color: white;
    border: none;
    border-radius: 12px;
    padding: 1rem 2rem;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    box-shadow: 0 4px 15px rgba(240, 149, 2, 0.3);
}

.submit-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(240, 149, 2, 0.4);
}

.submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.button-icon {
    font-size: 1.2rem;
}

.button-text {
    font-weight: 600;
}

/* ===== FORMULARIO MODERNO ===== */
.modern-form {
    background: linear-gradient(135deg, #1a1d29 0%, #0e0f15 100%);
    color: white;
    width: 100%;
    border: 2px solid #f09502;
    border-radius: 16px;
    padding: 2rem;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    position: relative;
    overflow: hidden;
}
.new-container form {
    background-color: var(--color-bg-dark);
    color: var(--color-text-white);
    width: 100%;
    border: 2px solid var(--color-primary);
    padding: var(--spacing-8) !important;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
}

.modern-form::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #f09502, #ff6b35, #f09502);
    background-size: 200% 100%;
    animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
    0%, 100% { background-position: 200% 0; }
    50% { background-position: -200% 0; }
}

/* ===== HEADER DEL FORMULARIO ===== */
.form-header {
    text-align: center;
    margin-bottom: 3rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid rgba(240, 149, 2, 0.2);
}

.form-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #f09502;
    margin-bottom: 0.5rem;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.form-subtitle {
    font-size: 1.1rem;
    color: #b8bcc8;
    margin: 0;
    font-weight: 300;
}

/* ===== SECCIONES DEL FORMULARIO ===== */
.form-section {
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(240, 149, 2, 0.1);
    border-radius: 12px;
    padding: 2rem;
    margin-bottom: 2rem;
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
}

.form-section:hover {
    border-color: rgba(240, 149, 2, 0.3);
    box-shadow: 0 8px 25px rgba(240, 149, 2, 0.1);
}

.section-header {
    margin-bottom: 2rem;
    text-align: center;
}

.section-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #f09502;
    margin-bottom: 0.5rem;
}

.section-description {
    color: #b8bcc8;
    font-size: 0.95rem;
    margin: 0;
}
.new-container .imgs {
    max-width: 50%;
    max-height: 200px;
}
.new-container .toBlockchain {
    padding: var(--spacing-2) var(--spacing-8);
    border: 1px solid var(--color-border-medium);
}

.errorInput {
    background-color: var(--color-danger);
    opacity: 0.2;
}

/* Estilos para el sistema de viviendas múltiples */
.vivienda-container {
    background-color: rgba(255, 255, 255, 0.05);
    border: 1px solid var(--color-primary) !important;
    transition: all 0.3s ease;
}

.vivienda-container:hover {
    background-color: rgba(255, 255, 255, 0.08);
    border-color: var(--color-primary-light) !important;
}

.vivienda-container .btn-danger {
    background-color: var(--color-danger);
    border-color: var(--color-danger);
    color: var(--color-text-white);
    padding: var(--spacing-2) var(--spacing-3);
    font-size: var(--font-size-sm);
    border-radius: var(--spacing-1);
    transition: all 0.15s ease-in-out;
}

.vivienda-container .btn-danger:hover {
    background-color: var(--color-danger-hover);
    border-color: var(--color-danger-hover);
    transform: scale(1.05);
}

.vivienda-container .btn-outline-primary {
    color: var(--color-primary);
    border-color: var(--color-primary);
    background-color: transparent;
}

.vivienda-container .btn-outline-primary:hover {
    color: var(--color-text-white);
    background-color: var(--color-primary);
    border-color: var(--color-primary);
}

/* ===== GRID DE FORMULARIOS ===== */
.form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
    align-items: start;
}

.form-group {
    display: flex;
    flex-direction: column;
}

.form-group.full-width {
    grid-column: 1 / -1;
}

/* ===== LABELS Y INPUTS ===== */
.form-label {
    font-size: 0.9rem;
    font-weight: 500;
    color: #e2e8f0;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

.form-control {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    color: white;
    padding: 0.75rem 1rem;
    font-size: 0.95rem;
    transition: all 0.3s ease;
    backdrop-filter: blur(5px);
}

.form-control:focus {
    outline: none;
    border-color: #f09502;
    box-shadow: 0 0 0 3px rgba(240, 149, 2, 0.1);
    background: rgba(255, 255, 255, 0.08);
}

.form-control::placeholder {
    color: rgba(255, 255, 255, 0.4);
}

.form-control.errorInput {
    background-color: rgba(255, 196, 196, 0.1);
    border-color: #ff4757;
    color: #ff4757;
}

/* ===== CHECKBOXES ===== */
.square-meters-with-checkboxes {
    grid-column: 1 / -1;
}

.input-with-checkboxes {
    display: flex;
    gap: 1.5rem;
    align-items: flex-start;
    flex-wrap: wrap;
}

.input-with-checkboxes .form-control {
    width: 100%;
    max-width: 300px;
}

.checkboxes-container {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    align-items: center;
}

.checkbox-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
    min-width: 120px;
    justify-content: flex-start;
}

.checkbox-item:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(240, 149, 2, 0.3);
    transform: translateY(-1px);
}

.form-check-input {
    width: 1.1rem;
    height: 1.1rem;
    accent-color: #f09502;
    cursor: pointer;
}

.form-check-label {
    color: #e2e8f0;
    font-weight: 500;
    cursor: pointer;
    font-size: 0.9rem;
}

/* ===== DOCUMENTOS ===== */
.documents-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.5rem;
}

.document-card {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    transition: all 0.3s ease;
}

.document-card:hover {
    border-color: rgba(240, 149, 2, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.document-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}

.document-title {
    color: #f09502;
    font-weight: 600;
    margin: 0;
    font-size: 1rem;
}

.document-format {
    background: rgba(240, 149, 2, 0.2);
    color: #f09502;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 500;
}

.document-hint {
    color: #b8bcc8;
    font-size: 0.85rem;
    margin-bottom: 1rem;
    font-style: italic;
}

.image-preview {
    margin-top: 1rem;
    text-align: center;
}

.preview-image {
    max-width: 100%;
    max-height: 150px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

/* ===== OPCIONES BLOCKCHAIN ===== */
.blockchain-options {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.option-card {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    transition: all 0.3s ease;
}

.option-card:hover {
    border-color: rgba(240, 149, 2, 0.3);
    background: rgba(255, 255, 255, 0.05);
}

.option-header {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
}

.option-label {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    cursor: pointer;
    flex: 1;
}

.option-icon {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
}

.option-title {
    color: #e2e8f0;
    font-weight: 600;
    font-size: 1.1rem;
}

.option-description {
    color: #b8bcc8;
    font-size: 0.9rem;
    line-height: 1.4;
}

/* ===== BOTÓN DE ENVÍO ===== */
.submit-section {
    text-align: center;
    margin-top: 3rem;
    padding-top: 2rem;
    border-top: 1px solid rgba(240, 149, 2, 0.2);
}

.submit-button {
    background: linear-gradient(135deg, #f09502 0%, #ff6b35 100%);
    border: none;
    border-radius: 12px;
    color: white;
    font-size: 1.1rem;
    font-weight: 600;
    padding: 1rem 3rem;
    min-width: 250px;
    transition: all 0.3s ease;
    box-shadow: 0 8px 25px rgba(240, 149, 2, 0.3);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.submit-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 12px 35px rgba(240, 149, 2, 0.4);
}

.submit-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
}

.button-icon {
    font-size: 1.2rem;
}

.button-text {
    font-weight: 600;
}

/* ===== IMÁGENES ADICIONALES ===== */
.imagenes {
    width: 100% !important;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
    margin-top: 1rem;
}

.imagenes > div {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 1rem;
    transition: all 0.3s ease;
}

.imagenes > div:hover {
    border-color: rgba(240, 149, 2, 0.3);
}

.imgs {
    max-width: 100%;
    max-height: 200px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 768px) {
    .modern-form {
        padding: 1.5rem;
        margin: 1rem;
    }
    
    .form-title {
        font-size: 2rem;
    }
    
    .form-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
    }
    
    .documents-grid {
        grid-template-columns: 1fr;
    }
    
    .blockchain-options {
        gap: 0.75rem;
    }
    
    .option-card {
        padding: 1rem;
    }
    
    .submit-button {
        width: 100%;
        min-width: auto;
    }
}

@media (max-width: 480px) {
    .modern-form {
        padding: 1rem;
        margin: 0.5rem;
    }
    
    .form-title {
        font-size: 1.75rem;
    }
    
    .form-section {
        padding: 1.5rem;
    }
    
    .section-title {
        font-size: 1.25rem;
    }
    
    .imagenes {
        grid-template-columns: 1fr;
    }
    
    .input-with-checkboxes {
        flex-direction: column;
        gap: 1rem;
    }
    
    .input-with-checkboxes .form-control {
        max-width: none;
        width: 100%;
    }
    
    .checkboxes-container {
        flex-direction: column;
        gap: 0.75rem;
        width: 100%;
    }
    
    .checkbox-item {
        min-width: auto;
        width: 100%;
        justify-content: flex-start;
        padding: 0.5rem 0.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/new-proyect.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mCAAmC;AACnC;IACI,6DAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,WAAW;IACX,sCAAsC;IACtC,oCAAoC;IACpC,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,6DAA6D;IAC7D,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;IACI,WAAW,2BAA2B,EAAE;IACxC,MAAM,4BAA4B,EAAE;AACxC;;AAEA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA,yCAAyC;AACzC;IACI,qCAAqC;IACrC,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,0CAA0C;IAC1C,4CAA4C;AAChD;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA,mDAAmD;AACnD;IACI,2CAA2C;IAC3C,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,mDAAmD;AACvD;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;IACjC,8BAA8B;IAC9B,0CAA0C;IAC1C,8BAA8B;IAC9B,+BAA+B;IAC/B,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;IAC5C,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;IAC1C,qBAAqB;IACrB,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,qCAAqC;IACrC,kBAAkB;IAClB,0CAA0C;IAC1C,yBAAyB;IACzB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,6CAA6C;IAC7C,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,sBAAsB;IACtB,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA,kCAAkC;AAClC;IACI;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;QACX,2BAA2B;QAC3B,uBAAuB;IAC3B;AACJ","sourcesContent":[":host {\n    width: 100%;\n    display: block;\n}\n\n.new-project-container {\n    width: 100%;\n    min-height: 100vh;\n    margin: 0;\n    padding: 2rem 0 0 0;\n    background: #fff;\n    position: relative;\n    z-index: 1;\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.new-project-form {\n    background: #fff;\n    border-radius: 0;\n    padding: 0;\n    box-shadow: none;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.tab-content {\n    padding: 2rem;\n    background: #fff;\n    border-radius: 0;\n    flex: 1;\n    overflow-y: auto;\n}\n\n.submit-section {\n    padding: 2rem 2rem 2rem 2rem;\n    background: #fff;\n    border-radius: 0;\n    text-align: center;\n    border-top: 1px solid #e9ecef;\n}\n\n.submit-button {\n    background: linear-gradient(135deg, #f09502, #ff6b35);\n    color: white;\n    border: none;\n    border-radius: 12px;\n    padding: 1rem 2rem;\n    font-size: 1.1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    box-shadow: 0 4px 15px rgba(240, 149, 2, 0.3);\n}\n\n.submit-button:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(240, 149, 2, 0.4);\n}\n\n.submit-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.button-icon {\n    font-size: 1.2rem;\n}\n\n.button-text {\n    font-weight: 600;\n}\n\n/* ===== FORMULARIO MODERNO ===== */\n.modern-form {\n    background: linear-gradient(135deg, #1a1d29 0%, #0e0f15 100%);\n    color: white;\n    width: 100%;\n    border: 2px solid #f09502;\n    border-radius: 16px;\n    padding: 2rem;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n    position: relative;\n    overflow: hidden;\n}\n.new-container form {\n    background-color: var(--color-bg-dark);\n    color: var(--color-text-white);\n    width: 100%;\n    border: 2px solid var(--color-primary);\n    padding: var(--spacing-8) !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.modern-form::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: linear-gradient(90deg, #f09502, #ff6b35, #f09502);\n    background-size: 200% 100%;\n    animation: shimmer 3s ease-in-out infinite;\n}\n\n@keyframes shimmer {\n    0%, 100% { background-position: 200% 0; }\n    50% { background-position: -200% 0; }\n}\n\n/* ===== HEADER DEL FORMULARIO ===== */\n.form-header {\n    text-align: center;\n    margin-bottom: 3rem;\n    padding-bottom: 2rem;\n    border-bottom: 1px solid rgba(240, 149, 2, 0.2);\n}\n\n.form-title {\n    font-size: 2.5rem;\n    font-weight: 700;\n    color: #f09502;\n    margin-bottom: 0.5rem;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.form-subtitle {\n    font-size: 1.1rem;\n    color: #b8bcc8;\n    margin: 0;\n    font-weight: 300;\n}\n\n/* ===== SECCIONES DEL FORMULARIO ===== */\n.form-section {\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid rgba(240, 149, 2, 0.1);\n    border-radius: 12px;\n    padding: 2rem;\n    margin-bottom: 2rem;\n    backdrop-filter: blur(10px);\n    transition: all 0.3s ease;\n}\n\n.form-section:hover {\n    border-color: rgba(240, 149, 2, 0.3);\n    box-shadow: 0 8px 25px rgba(240, 149, 2, 0.1);\n}\n\n.section-header {\n    margin-bottom: 2rem;\n    text-align: center;\n}\n\n.section-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #f09502;\n    margin-bottom: 0.5rem;\n}\n\n.section-description {\n    color: #b8bcc8;\n    font-size: 0.95rem;\n    margin: 0;\n}\n.new-container .imgs {\n    max-width: 50%;\n    max-height: 200px;\n}\n.new-container .toBlockchain {\n    padding: var(--spacing-2) var(--spacing-8);\n    border: 1px solid var(--color-border-medium);\n}\n\n.errorInput {\n    background-color: var(--color-danger);\n    opacity: 0.2;\n}\n\n/* Estilos para el sistema de viviendas múltiples */\n.vivienda-container {\n    background-color: rgba(255, 255, 255, 0.05);\n    border: 1px solid var(--color-primary) !important;\n    transition: all 0.3s ease;\n}\n\n.vivienda-container:hover {\n    background-color: rgba(255, 255, 255, 0.08);\n    border-color: var(--color-primary-light) !important;\n}\n\n.vivienda-container .btn-danger {\n    background-color: var(--color-danger);\n    border-color: var(--color-danger);\n    color: var(--color-text-white);\n    padding: var(--spacing-2) var(--spacing-3);\n    font-size: var(--font-size-sm);\n    border-radius: var(--spacing-1);\n    transition: all 0.15s ease-in-out;\n}\n\n.vivienda-container .btn-danger:hover {\n    background-color: var(--color-danger-hover);\n    border-color: var(--color-danger-hover);\n    transform: scale(1.05);\n}\n\n.vivienda-container .btn-outline-primary {\n    color: var(--color-primary);\n    border-color: var(--color-primary);\n    background-color: transparent;\n}\n\n.vivienda-container .btn-outline-primary:hover {\n    color: var(--color-text-white);\n    background-color: var(--color-primary);\n    border-color: var(--color-primary);\n}\n\n/* ===== GRID DE FORMULARIOS ===== */\n.form-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 1.5rem;\n    align-items: start;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n}\n\n.form-group.full-width {\n    grid-column: 1 / -1;\n}\n\n/* ===== LABELS Y INPUTS ===== */\n.form-label {\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: #e2e8f0;\n    margin-bottom: 0.5rem;\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n.form-control {\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n    color: white;\n    padding: 0.75rem 1rem;\n    font-size: 0.95rem;\n    transition: all 0.3s ease;\n    backdrop-filter: blur(5px);\n}\n\n.form-control:focus {\n    outline: none;\n    border-color: #f09502;\n    box-shadow: 0 0 0 3px rgba(240, 149, 2, 0.1);\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.form-control::placeholder {\n    color: rgba(255, 255, 255, 0.4);\n}\n\n.form-control.errorInput {\n    background-color: rgba(255, 196, 196, 0.1);\n    border-color: #ff4757;\n    color: #ff4757;\n}\n\n/* ===== CHECKBOXES ===== */\n.square-meters-with-checkboxes {\n    grid-column: 1 / -1;\n}\n\n.input-with-checkboxes {\n    display: flex;\n    gap: 1.5rem;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.input-with-checkboxes .form-control {\n    width: 100%;\n    max-width: 300px;\n}\n\n.checkboxes-container {\n    display: flex;\n    gap: 1rem;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.checkbox-item {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    background: rgba(255, 255, 255, 0.03);\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    transition: all 0.3s ease;\n    min-width: 120px;\n    justify-content: flex-start;\n}\n\n.checkbox-item:hover {\n    background: rgba(255, 255, 255, 0.05);\n    border-color: rgba(240, 149, 2, 0.3);\n    transform: translateY(-1px);\n}\n\n.form-check-input {\n    width: 1.1rem;\n    height: 1.1rem;\n    accent-color: #f09502;\n    cursor: pointer;\n}\n\n.form-check-label {\n    color: #e2e8f0;\n    font-weight: 500;\n    cursor: pointer;\n    font-size: 0.9rem;\n}\n\n/* ===== DOCUMENTOS ===== */\n.documents-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 1.5rem;\n}\n\n.document-card {\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 12px;\n    padding: 1.5rem;\n    transition: all 0.3s ease;\n}\n\n.document-card:hover {\n    border-color: rgba(240, 149, 2, 0.3);\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\n}\n\n.document-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1rem;\n}\n\n.document-title {\n    color: #f09502;\n    font-weight: 600;\n    margin: 0;\n    font-size: 1rem;\n}\n\n.document-format {\n    background: rgba(240, 149, 2, 0.2);\n    color: #f09502;\n    padding: 0.25rem 0.5rem;\n    border-radius: 4px;\n    font-size: 0.75rem;\n    font-weight: 500;\n}\n\n.document-hint {\n    color: #b8bcc8;\n    font-size: 0.85rem;\n    margin-bottom: 1rem;\n    font-style: italic;\n}\n\n.image-preview {\n    margin-top: 1rem;\n    text-align: center;\n}\n\n.preview-image {\n    max-width: 100%;\n    max-height: 150px;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* ===== OPCIONES BLOCKCHAIN ===== */\n.blockchain-options {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.option-card {\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 12px;\n    padding: 1.5rem;\n    transition: all 0.3s ease;\n}\n\n.option-card:hover {\n    border-color: rgba(240, 149, 2, 0.3);\n    background: rgba(255, 255, 255, 0.05);\n}\n\n.option-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 1rem;\n}\n\n.option-label {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    cursor: pointer;\n    flex: 1;\n}\n\n.option-icon {\n    font-size: 1.5rem;\n    margin-bottom: 0.5rem;\n}\n\n.option-title {\n    color: #e2e8f0;\n    font-weight: 600;\n    font-size: 1.1rem;\n}\n\n.option-description {\n    color: #b8bcc8;\n    font-size: 0.9rem;\n    line-height: 1.4;\n}\n\n/* ===== BOTÓN DE ENVÍO ===== */\n.submit-section {\n    text-align: center;\n    margin-top: 3rem;\n    padding-top: 2rem;\n    border-top: 1px solid rgba(240, 149, 2, 0.2);\n}\n\n.submit-button {\n    background: linear-gradient(135deg, #f09502 0%, #ff6b35 100%);\n    border: none;\n    border-radius: 12px;\n    color: white;\n    font-size: 1.1rem;\n    font-weight: 600;\n    padding: 1rem 3rem;\n    min-width: 250px;\n    transition: all 0.3s ease;\n    box-shadow: 0 8px 25px rgba(240, 149, 2, 0.3);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n.submit-button:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 12px 35px rgba(240, 149, 2, 0.4);\n}\n\n.submit-button:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.button-icon {\n    font-size: 1.2rem;\n}\n\n.button-text {\n    font-weight: 600;\n}\n\n/* ===== IMÁGENES ADICIONALES ===== */\n.imagenes {\n    width: 100% !important;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 1rem;\n    margin-top: 1rem;\n}\n\n.imagenes > div {\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n    padding: 1rem;\n    transition: all 0.3s ease;\n}\n\n.imagenes > div:hover {\n    border-color: rgba(240, 149, 2, 0.3);\n}\n\n.imgs {\n    max-width: 100%;\n    max-height: 200px;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* ===== RESPONSIVE DESIGN ===== */\n@media (max-width: 768px) {\n    .modern-form {\n        padding: 1.5rem;\n        margin: 1rem;\n    }\n    \n    .form-title {\n        font-size: 2rem;\n    }\n    \n    .form-grid {\n        grid-template-columns: 1fr;\n        gap: 1rem;\n    }\n    \n    .documents-grid {\n        grid-template-columns: 1fr;\n    }\n    \n    .blockchain-options {\n        gap: 0.75rem;\n    }\n    \n    .option-card {\n        padding: 1rem;\n    }\n    \n    .submit-button {\n        width: 100%;\n        min-width: auto;\n    }\n}\n\n@media (max-width: 480px) {\n    .modern-form {\n        padding: 1rem;\n        margin: 0.5rem;\n    }\n    \n    .form-title {\n        font-size: 1.75rem;\n    }\n    \n    .form-section {\n        padding: 1.5rem;\n    }\n    \n    .section-title {\n        font-size: 1.25rem;\n    }\n    \n    .imagenes {\n        grid-template-columns: 1fr;\n    }\n    \n    .input-with-checkboxes {\n        flex-direction: column;\n        gap: 1rem;\n    }\n    \n    .input-with-checkboxes .form-control {\n        max-width: none;\n        width: 100%;\n    }\n    \n    .checkboxes-container {\n        flex-direction: column;\n        gap: 0.75rem;\n        width: 100%;\n    }\n    \n    .checkbox-item {\n        min-width: auto;\n        width: 100%;\n        justify-content: flex-start;\n        padding: 0.5rem 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
